<template>

    <div class="d-inline" v-if="isBlocked" >
        <a href="#" class="text-underline" target="_blank" @click.prevent="reveal()">megjelenít</a>
    </div>
    <div class="d-inline" v-else>
        <a :href="emailLink">{{ emailText }}</a>
    </div>

</template>

<script>
    export default {
        props: ['email'],

        data: function() {
            return {
                emailLink: '',
                emailText: '',
                blocked: true,
            }
        },

        mounted() {
            // Init from passed parameter
            this.emailLink = 'mailto:' + this.email;
            this.emailText = this.email;
        },

        computed: {
            isBlocked() {
                return this.blocked;
            },
        },

        methods: {
            reveal() {
                this.blocked = false;

                window.dataLayer.push({
                    'event': 'reveal.email',
                });
            }
        }
    }
</script>
